/**
 * @generated SignedSource<<6143947f51522c5923f13a7416df71f4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: nx generate-api-types
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ReadNotificationMutation$variables = {
  id: string;
};
export type ReadNotificationMutation$data = {
  readonly readNotificationV3: {
    readonly id: string;
  } | null | undefined;
};
export type ReadNotificationMutation = {
  response: ReadNotificationMutation$data;
  variables: ReadNotificationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "NotificationV3",
    "kind": "LinkedField",
    "name": "readNotificationV3",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ReadNotificationMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ReadNotificationMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "93f28d4e1f43ce6e6f46e631a5b6b3cc",
    "id": null,
    "metadata": {},
    "name": "ReadNotificationMutation",
    "operationKind": "mutation",
    "text": "mutation ReadNotificationMutation(\n  $id: ID!\n) {\n  readNotificationV3(id: $id) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "87b6acff3bc534deafaa8d17596cad8e";

export default node;
